import { render, staticRenderFns } from "./FormDisposalProcess.vue?vue&type=template&id=5b0c1039&scoped=true"
import script from "./FormDisposalProcess.vue?vue&type=script&lang=js"
export * from "./FormDisposalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c1039",
  null
  
)

export default component.exports